import { useId } from 'react';
import { BellRing } from 'lucide-react';
import { Button } from '@/components/ui';
import type { FollowToggle } from '@/hooks/useFollowToggle';

/**
 * "Follow {Brand} for alerts" on an upcoming or ended promotion (master D-4,
 * "Page shows": follow CTA), with a Follow / Following button. The button is
 * the brand's own toggle (`useFollowToggle`): a guest goes to /login, and a
 * member's follow is the same one the brand page shows. The sentence wraps on
 * a phone (a long brand name never overflows) and describes the button.
 */
export function FollowForAlerts({
  name,
  follow,
  className,
}: {
  /** The cleaned brand name. */
  name: string;
  follow: Pick<FollowToggle, 'subscribed' | 'subscribing' | 'toggleFollow'>;
  className?: string;
}) {
  const textId = useId();
  return (
    <div
      className={`flex flex-wrap items-center gap-3 rounded-2xl border border-line bg-card p-4 ${className ?? ''}`}
    >
      <BellRing size={20} className="shrink-0 text-primary" aria-hidden="true" />
      <p id={textId} className="min-w-0 flex-1 basis-40 font-semibold text-ink">
        Follow {name} for alerts
      </p>
      <Button
        size="sm"
        variant={follow.subscribed ? 'outline' : 'primary'}
        loading={follow.subscribing}
        onClick={follow.toggleFollow}
        aria-describedby={textId}
      >
        {follow.subscribed ? 'Following' : 'Follow'}
      </Button>
    </div>
  );
}

export default FollowForAlerts;
